import { makeStyles } from '@mui/styles';
import colors from "../../../../common/styles/colors";

export default makeStyles({
  scanningResultContainer: {
    maxHeight: '335px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',

    "& .main-spinner-container": {
      margin: '114px 0',
      position: 'inherit !important'
    }
  },
  fingerprintIcon: {
    marginTop: '35px',
    width: '80px',
    height: '80px',
    color: colors.lightGrey4
  },
  scannedBadgeDesc: {
    margin: '0',
    paddingTop: '10px',
    fontSize: '12px'
  },
  badgeOwner: {
    margin: '0',
    marginBottom: '35px',
    paddingTop: '8px',
    fontSize: '18px',
    fontWeight: 600
  },
  noInternetMessage: {
    marginTop: '0 !important'
  },
  userSvgWrapper: {
    padding: '1rem 2rem',
    backgroundColor: colors.white,
    borderRadius: '11px',
    marginTop: '1rem'
  },
  photoPlaceholder: {
    marginTop: '35px',
    width: '247px',
    height: '242px'
  },
  contentContainer: { display: 'flex', flexDirection: 'column', alignItems: 'center' },
  scannerContainer: { width: '100%', position: 'relative' },
  loaderContainer: { position: "absolute", top: "50%", left: "50%", zIndex: 999, transform: "translate(-50%,-50%)" }
});
